'use strict';

import dialog from '../dialog';

export default {
    init: function () {
    $('.store-details-link').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });
    }
};

$('#boutique-parent').click(function() {
    $('html, body').animate({
        scrollTop: $('#boutique-services-block').offset().top - 120
    }, 1000);
});

$('#boutique-girls-night-out').click(function() {
    $('html, body').animate({
        scrollTop: $('#boutique-store-events').offset().top - 120
    }, 1000);
});


